import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-task-detail-page',
  templateUrl: './task-detail-page.component.html',
  styleUrls: ['./task-detail-page.component.scss'],
  standalone: false,
})
export class TaskDetailPageComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);

  orgId: string;
  taskId: string;
  focus: 'thread' | undefined;

  subscriptions = new Subscription();

  ngOnInit(): void {
    const sub = this.route.data.subscribe((data) => {
      let focus = data.focus;
      if (focus !== undefined && focus !== 'thread') {
        console.error('unknown focus type from route:' + focus);
        focus = undefined;
      }

      this.orgId = this.route.snapshot.params.orgId;
      this.taskId = this.route.snapshot.params.taskId;
      this.focus = focus;
    });
    this.subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
